import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const KEY = "scada_selected_site";

export function useSiteSelector() {
  const [sites, setSites] = useState([]);
  const [siteId, setSiteIdRaw] = useState(() => localStorage.getItem(KEY) || "");

  useEffect(() => {
    api.get("/sites").then(({ data }) => {
      setSites(data);
      if (data.length && !data.find(s => s.id === siteId)) {
        setSiteId(data[0].id);
      }
    });
  }, []);

  const setSiteId = (id) => {
    setSiteIdRaw(id);
    if (id) localStorage.setItem(KEY, id);
  };

  return { sites, siteId, setSiteId };
}

export default function SiteSelector({ sites, siteId, setSiteId, allowAll = false, testId = "site-select" }) {
  if (!sites || sites.length === 0) {
    return <div className="scada-panel px-3 py-2 text-[#5A6573] font-mono-metric text-xs">NO SITES ASSIGNED</div>;
  }
  return (
    <div className="flex items-center gap-2">
      <div className="scada-label">PLANT</div>
      <select
        data-testid={testId}
        value={siteId}
        onChange={(e) => setSiteId(e.target.value)}
        className="border px-3 py-2 text-sm font-mono-metric min-w-[220px]"
      >
        {allowAll && <option value="">All sites</option>}
        {sites.map(s => <option key={s.id} value={s.id}>{s.name} — {s.customer}</option>)}
      </select>
    </div>
  );
}
